/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const getExportReportActivitiesQueryParamsSchema = z.object({
  Groups: z.string(),
  Filters: z.string().optional(),
  SortOrder: z.string().optional(),
  PageNumber: z.coerce.number().int(),
  PageSize: z.coerce.number().int(),
});

/**
 * @description OK
 */
export const getExportReportActivities200Schema = z.any();

export const getExportReportActivitiesQueryResponseSchema = z.lazy(
  () => getExportReportActivities200Schema,
);
